<template>
  <v-layout class="fill-height">
    <v-row v-if="assignmentAllowed" class="fill-height ma-0">
      <v-col cols="12" md="12" class="pa-2">
        <v-card :style="{ backgroundColor: backgroundColor }">
          <v-tabs
            v-model="activeTab"
            show-arrows="false"
            touch="false"
            >
            <v-tab value="overview">{{ $t('overview') }}</v-tab>
            <v-tab value="assignment">{{ $t('assignment') }}</v-tab>
          </v-tabs>

          <v-card-text>
            <v-window v-model="activeTab" disabled>
              <v-window-item value="overview">
                <v-sheet :style="{ backgroundColor: backgroundColor }" class="pa-2">
                  <TeamsPageOverview v-if="activeTab === 'overview'" />
                </v-sheet>
              </v-window-item>

              <v-window-item value="assignment"> 
                <TeamsPageAssignment 
                   v-if="activeTab === 'assignment'"
                  :assignableTeamIds="assignableTeamIds"
                />
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="12" class="pa-2">
        <TeamsPageOverview />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
